import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";
import { store } from "../../store";

export default function* watcherAddCustomerInfoSaga() {
  yield takeEvery("ADD_CUTSTOMER_INFO", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    yield request(
      "post",
      action.payload,
      "api/SalesTransactionV2/add-customer"
    ).then((response) => {
      payload = response;
    });
    console.log("Customer Loader", payload);
    toast.success(payload);
    yield request("get", payload, "api/Admin/get-countries-dropdown").then(
      (response) => {
        payload = response;
      }
    );
    yield put({ type: "COUNTRIES_DROPDOWN", payload: payload });
    yield request("get", payload, "/api/Admin/get-states").then((response) => {
      payload = response;
    });
    yield put({ type: "STATE_DROPDOWN", payload: payload });
    const formatUrl =
      "api/SalesTransactionV2/get-customers?companyId=" +
      store.getState().persistReducer.companyId;
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "CUSTOMER_INFO", payload: payload });
    var customers = [];
    for (var i = 0; i < payload.length; i++) {
      customers.push({
        id: payload[i].id,
        title: payload[i].name,
      });
    }
    yield put({ type: "CUSTOMER_INFO_DROP", payload: customers });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-user-saga", e);
    console.log("add-user-saga", e.response);
    console.log(e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
